import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { INBOX_CHANGE } from './threadRemovalTypes';
const InboxChangeRemoval = Record({
  [THREAD_REMOVAL_TYPE]: INBOX_CHANGE,
  audit: null,
  members: List(),
  inboxId: null
}, 'InboxChangeRemoval');
export default InboxChangeRemoval;